import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, IonInput, LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import format from 'date-fns/format';
import { Observable, of } from 'rxjs';
import { AttivitaReale } from 'src/app/models/didattica/attivita-reale';
import { Docente } from 'src/app/models/didattica/docente';
import { Rilevazione } from 'src/app/models/rilevazione-presenze/rilevazione';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { DidatticaService } from 'src/app/services/didattica-service';
import { RilevazionePresenzeService } from 'src/app/services/rilevazione-presenze-service';
import { UserService } from 'src/app/services/user-service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
    selector: 'app-modifica-rilevazione',
    templateUrl: './modifica-rilevazione.component.html',
    styleUrls: ['./modifica-rilevazione.component.scss'],
    standalone: false
})
export class ModificaRilevazioneComponent implements OnInit {

  @Input() rilevazione: Rilevazione;
  @ViewChild('dateTimeStart', { static: true }) dateTimeStart: IonInput;
  @ViewChild('dateTimeEnd', { static: true }) dateTimeEnd: IonInput;

  protected loader;
  protected form: FormGroup;
  protected formInitialValue;
  protected attivita: AttivitaReale[];
  protected docente;
  protected ar;
  protected hasChange = false;
  protected formatString = 'yyyy-MM-dd' + '\'T\'' + 'HH:mm';
  protected dataCorrente = format(new Date(), this.formatString);
  protected minutiConsentiti = [15, 30, 45];
  protected validDate = true;
  protected confirmDisabled: boolean;
  protected istanteCreazione: string;
  protected istanteChiusura: string;
  protected isBackdropVisible = false;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private didatticaService: DidatticaService,
    private userService: UserService,
    private utilityService: UtilityService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    public rilevazionePresenzeService: RilevazionePresenzeService,
    public configService: ConfigService
  ) {

    this.form = this.formBuilder.group({
      attivitaReale: [
        Validators.required
      ],
      istanteCreazione: [
        Validators.required
      ],
      chiusuraAnticipata: [
      ],
      moveMarcature: [
      ],
      moveChiusura: [
      ],
      ore: [
        Validators.compose([
          // Validators.minLength(1),
          Validators.maxLength(2),
          Validators.pattern('[0-9 ]*'),
          Validators.required
        ])
      ],
      minuti: [
        Validators.compose([
          Validators.maxLength(2),
        ])
      ],
      moderoglezione: [
        Validators.compose([
          Validators.maxLength(2),
        ])
      ],
      tipoAttivita: [
      ],
      tipoAttivitaDesc: [
      ],
      note: [
        '',
        Validators.compose([
          Validators.maxLength(1000),
        ])
      ]
  });
  this.form.valueChanges.subscribe((v) => {
    console.log('v', v);
    if ( v.ore < 0 )  {
      return;
    }
    if ((!v.minuti && ( v.ore === 0 || v.ore === null)) ) {
      this.form.controls['minuti'].setErrors({'incorrect': true});
      this.form.controls['ore'].setErrors({'incorrect': true});
    } else {
      this.form.controls['minuti'].setErrors(null);
      this.form.controls['ore'].setErrors(null);
    }
  });
  }

  async ngOnInit() {
    this.docente = this.userService.getDocenteCorrente();
    await this.caricaAttivita(this.docente);
    await this.caricaAttivitaRilevazione(this.docente);

    const hoursFraction = this.rilevazione.durata % 60;
    const durata = this.rilevazione.durata - hoursFraction;
    this.form.controls['ore'].setValue(durata / 60);
    this.form.controls['minuti'].setValue(hoursFraction);
    this.form.controls['istanteCreazione'].setValue(format(new Date(this.rilevazione.istanteCreazione), this.formatString));

    this.istanteCreazione = format(new Date(this.rilevazione.istanteCreazione), this.formatString);
    // this.chiusuraRil = format(new Date(this.rilevazione.istanteCreazione).getTime() +
    //                                         (this.rilevazione.durata * 60000), this.formatString);
    // this.istanteChiusura = this.chiusuraRil;

    if (this.rilevazione.chiusuraAnticipata) {
      this.form.controls['chiusuraAnticipata'].setValue(format(new Date(this.rilevazione.chiusuraAnticipata), this.formatString));
    } else {
      this.form.controls['chiusuraAnticipata'].setValue(null);
    }
    if (this.rilevazione.note) {
      this.form.controls['note'].setValue(this.rilevazione.note);
    }
    if (this.rilevazione.modalitaErogazione) {
      const m = this.rilevazionePresenzeService.decodeModalita(this.rilevazione.modalitaErogazione);
      this.form.controls['moderoglezione'].setValue(m);
    }
    if (this.configService.indicaTipoAttivita && this.rilevazione.ar.suddivisioneOre) {
       this.form.controls['tipoAttivita'].setValue(this.rilevazione.tipoAttivita);
       this.setTipoAttivitaDesc(this.rilevazione.tipoAttivita);
    }


    this.formInitialValue = this.form.value;
  }

  protected onSelectableOpen() {
    this.isBackdropVisible = true;
  }
  protected onSelectableClose() {
    this.isBackdropVisible = false;
  }
  checkFormChanges(key: string) {
    this.hasChange = this.form.value[key] !== this.formInitialValue[key];
  }

  async annulla() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  arChanges(event: any) {
    console.log('ar', this.ar);
  }

  async caricaAttivita(docente: Docente) {
    if (docente) {
      await this.didatticaService
        .cercaAttivitaReali(docente)
        .subscribe(attivita => (this.attivita = attivita));
    } else { this.attivita = []; }
  }

  async caricaAttivitaRilevazione(docente: Docente) {
    if (docente) {
      await this.didatticaService
        .cercaAttivitaReali(docente)
        .subscribe(attivita => {
          let arRil;
          for (let i = 0; attivita.length > i; i++) {
            if (attivita[i].id === this.rilevazione.ar.id) {
              arRil = attivita[i];
              this.form.controls['attivitaReale'].setValue(arRil);
              return arRil;
            }
          }
          arRil = this.rilevazione.ar;
          this.form.controls['attivitaReale'].setValue(arRil);
          return arRil;
        });
    } else { return; }
  }

  cercaAttivita(
    service: RilevazionePresenzeService,
    search: string
  ): Observable<any> {
    return of({});
  }

  async checkValidation() {
    const presenzeStu = [];
    this.rilevazionePresenzeService.getPresenze(this.rilevazione)
    .subscribe(async presenze => {
      presenze.forEach(presenza => {
        if (!presenza.idOperatore) {
          presenzeStu.push(presenza);
        }
      });

      let dateVerifica = null;

      if (this.rilevazione.richiestaConferma) {
        dateVerifica = format(new Date(this.rilevazione.richiestaConferma.istanteRichiesta), this.formatString);
      }

      // Check Date
      if (this.form.get('chiusuraAnticipata').value &&  this.istanteCreazione > this.istanteChiusura) {
        this.utilityService.presentToast(this.translateService.instant('modifica-rilevazione.msg.toast'));
        this.loader.dismiss();
      } else if ((this.form.get('chiusuraAnticipata').value) &&
            (+format(new Date(this.form.get('istanteCreazione').value), 'yyyy') < +this.rilevazione.ar.annoAccademico ||
             +format(new Date(this.form.get('chiusuraAnticipata').value), 'yyyy') < +this.rilevazione.ar.annoAccademico)) {
        this.utilityService.presentToast(this.translateService.instant('modifica-rilevazione.msg.toast-anno'));
        this.loader.dismiss();
      } else if ((this.form.get('chiusuraAnticipata').value) && (this.form.get('istanteCreazione').value >= dateVerifica ||
            this.form.get('chiusuraAnticipata').value <= dateVerifica)) {
        this.utilityService.presentToast(this.translateService.instant('modifica-rilevazione.msg.toast-verifica'));
        this.loader.dismiss();
      } else if (presenzeStu.length > 0 && this.form.get('moveMarcature').value) {
        const alert = await this.alertCtrl.create({
          header: this.translateService.instant('label.warning'),
          message: this.translateService.instant('modifica-rilevazione.msg.warning'),
          buttons: [{
                      text: this.translateService.instant('label.confirm'),
                      handler: () => {
                          this.saveModifiche();
                      }
                  },
                  {
                      text: this.translateService.instant('label.cancel'),
                      handler: () => {
                        this.confirmDisabled = false;
                      }
                  }]
        });

        alert.addEventListener('ionAlertDidPresent', () => {
          this.loader.dismiss();
        });

      return await alert.present();
      } else {
        this.saveModifiche();
        this.loader.dismiss();
      }
    });
  }

  moveChiusuraAnticipata() {
    if ((this.form.get('chiusuraAnticipata').value)) {
      if (this.form.get('moveChiusura').value) {
        const istanteChiusura = format(new Date(this.form.get('istanteCreazione').value).getTime() +
                                  (this.rilevazione.durataReale * 60000), this.formatString);
        this.form.controls['chiusuraAnticipata'].setValue(istanteChiusura);
      } else {
        this.form.controls['chiusuraAnticipata'].setValue(format(new Date(this.rilevazione.chiusuraAnticipata), this.formatString));
      }
    }
  }

  selezionaTipoAttivita(event: any) {
    console.log('event', event);
    if (event) {
      this.setTipoAttivitaDesc(event.detail.value);
    }
  }

  setTipoAttivitaDesc(cod: string) {
       this.form.controls['tipoAttivitaDesc'].setValue(
        this.rilevazione.ar.suddivisioneOre.find(sudd => sudd.cod === cod)?.desc
       );
  }

  async confirm() {
    this.loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });

    this.loader.present();
    this.confirmDisabled = true;

    this.checkFormChanges('istanteCreazione');

    if (this.hasChange) {
      await this.checkValidation();
    } else {
      this.checkFormChanges('chiusuraAnticipata');
      if (this.hasChange) {
        await this.checkValidation();
      } else {
        this.saveModifiche();
        this.loader.dismiss();
      }
    }
  }

  async saveModifiche() {
    const ril: Rilevazione = {...this.rilevazione};

    if(!this.form.get('minuti').value) {
      this.form.get('minuti').setValue(0);
    }

    if (this.form.get('minuti').value !== 0) {
      const ore = this.form.get('ore').value * 60;
      const minuti = +this.form.get('minuti').value;
      ril.durata = ore + minuti;
    } else {
      ril.durata = this.form.get('ore').value * 60;
    }

    ril.istanteCreazione = new Date(this.form.get('istanteCreazione').value);
    if (this.form.get('chiusuraAnticipata').value !== null) {
      ril.chiusuraAnticipata = new Date(this.form.get('chiusuraAnticipata').value);
    }
    ril.note = this.form.get('note').value;
    ril.ar = this.form.get('attivitaReale').value;
    const data = {ril: ril, moveMarcature: this.form.controls['moveMarcature'].value};
    ril.modalitaErogazione = this.rilevazionePresenzeService.getModalita(this.form.get('moderoglezione').value);
    ril.tipoAttivita = this.form.get('tipoAttivita').value;
    ril.tipoAttivitaDesc = this.form.get('tipoAttivitaDesc').value;
    await this.modalCtrl.dismiss(data, 'cancel');
  }

  checkDate(type: string) {
    if (type === 'start') {
      if (this.form.get('istanteCreazione').value === null) {
        this.validDate = false;
      } else {
        if (this.istanteCreazione !== this.form.get('istanteCreazione').value) {
          this.istanteCreazione = this.form.get('istanteCreazione').value;
          if (this.form.get('chiusuraAnticipata').value) {
            if (this.form.get('moveChiusura').value) {
              this.istanteChiusura = format(new Date(this.form.get('istanteCreazione').value).getTime() +
                                                                          (this.rilevazione.durataReale * 60000), this.formatString);
              this.form.controls['chiusuraAnticipata'].setValue(this.istanteChiusura);
            }
          } else {
            this.form.controls['chiusuraAnticipata'].setValue('');
            this.istanteChiusura = format(new Date(this.form.get('istanteCreazione').value).getTime() +
                                                                         (this.rilevazione.durata * 60000), this.formatString);
          }
        }
        if (this.form.get('chiusuraAnticipata').value !== null) {
          this.validDate = true;
        }
      }
    }
    if (type === 'end') {
      if (this.form.get('chiusuraAnticipata').value === null) {
        this.validDate = false;
      } else {
        this.istanteChiusura = this.form.get('chiusuraAnticipata').value;
        this.validDate = true;
      }
    }
  }

  async openDateTimePicker(type: string) {
    console.log('type', type);
    if (type === 'start') {
      (await this.dateTimeStart.getInputElement()).showPicker();
    }
    if (type === 'end') {
      (await this.dateTimeEnd.getInputElement()).showPicker();
    }
  }
}
